import styled from "styled-components";

export const P = styled.p`
	text-align: center;
	color: black;
`;
